"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CustomLabel["default"];
  }
});
var _CustomLabel = _interopRequireDefault(require("./CustomLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }